import React, { useState, useContext, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";

// third-party
import { Accordion } from "react-bootstrap";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import AccordionContext from "react-bootstrap/AccordionContext";

// project-imports
import { GoogleAnalyticsEnum, triggerFunction } from "../../utils/google-analytics";
import SharingModal from "../reusable/SharingModal";
import { getQuestionNumber, toUpperSnake } from "../../utils";
import PaginationOne from '../../components/pagination/PaginationOne';
import ToolTip from "../../common/Tooltip/ToolTip";

export default function InterviewQuestionListAccordion({ data, activeTab, tabs, handleTab }) {
    // Reading URL params
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get("page")) || 1;
    const question = Number(searchParams.get("question")) || "1";

    // State initalization
    const [selectedQuestionId, setselectedQuestionId] = useState("0");
    const [toggler, setToggler] = useState(false);
    const [shareUrl, setShareUrl] = useState("");
    const [currentItems, setCurrentItems] = useState([]);
    const [initialPage, setInitialPage] = useState(0);

    // Find index of current Tab
    const currentIndex =
        tabs &&
        tabs.length &&
        tabs?.findIndex((elm) => elm?.slug === activeTab);

    // Find  prev index
    const prevIndex = currentIndex ? currentIndex - 1 : -1;

    // Find prev Tab
    const prevTab = prevIndex !== -1 ? tabs[prevIndex] : null;

    // Find next index
    const nextIndex = currentIndex ? (currentIndex + 1) % tabs?.length : +1;

    // Find next Tab
    const nextTab = nextIndex ? tabs[nextIndex] : null;

    const itemsPerPage = 10;
    const pageCount = Math.ceil((data || [])?.length / itemsPerPage);

    // Constant functions
    const handlePageClick = (event) => {
        try {
            // 1. Get the zero-based index of the clicked page
            const currentPage = event.selected;

            // Update your React state with the chosen index
            setInitialPage(currentPage);
            const newOffset = currentPage * itemsPerPage;
            window.scrollTo({ top: 0, behavior: "smooth" });
            handlePageGeneration(newOffset);
        } catch (error) {
            console.log("43 : InterviewQuestionAccordian : Error while changing page :: ", error);
            throw error;
        }
    };

    const handlePageGeneration = (itemOffset) => {
        try {
            const endOffset = itemOffset + itemsPerPage;
            const newItems = (data || [])?.slice(itemOffset, endOffset).slice(0, itemsPerPage);
            setCurrentItems(newItems);
        } catch (error) {
            console.log("54 : InterviewQuestionAccordian : Error while generating page :: ", error);
            throw error;
        }
    };


    // handlling pagination & redirects
    useEffect(() => {
        if (!data?.length) return;

        const pageIndex = page - 1;
        const offset = pageIndex * itemsPerPage;
        const questionIndex = question - (pageIndex * itemsPerPage) - 1;

        setselectedQuestionId(questionIndex.toString());
        setInitialPage(pageIndex);

        handlePageGeneration(offset);
        if (offset) {
            setTimeout(() => {
                document.getElementById(`question-${question}`)?.scrollIntoView({
                    behavior: "smooth",
                    block: "end",
                });
            }, 200);
        }

    }, [data]);

    // Constant function
    const CustomToggle = ({ children, eventKey, index }) => {
        const { activeEventKey } = useContext(AccordionContext);
        const decoratedOnClick = useAccordionButton(eventKey);
        const isCurrentEventKey = activeEventKey === eventKey;
        return (
            <button
                type="button"
                onClick={() => {
                    decoratedOnClick();
                }}
                aria-expanded={isCurrentEventKey ? true : false}
                className="edu-accordion-button"
            >
                {children}
            </button>
        ); // return <button type="button" onClick={decoratedOnClick} aria-expanded={isCurrentEventKey ? true : false} className="edu-accordion-button">{children}</button>
    };


    // Constant function
    const toggleQuestion = (id, elm, i) => {
        try {
            if (selectedQuestionId === id) {
                setselectedQuestionId(null);
            } else {
                setselectedQuestionId(id);
                triggerFunction(
                    GoogleAnalyticsEnum.BUTTON,
                    `TAB_${toUpperSnake(activeTab)}_QUESTION_${i + 1}`,
                )
            }
        } catch (error) {
            console.log(
                "116: InterviewQuestionListAccordion :Error while toggling Questions",
                JSON.stringify(error && error.message),
            );
        }
    }

    const getTags = (elm) => {
        try {
            return elm?.tags?.map((item) => <a href="#">{item}</a>);
        } catch (error) {
            console.log(
                "127: InterviewQuestionListAccordion :Error while getTags",
                JSON.stringify(error && error.message),
            );
        }
    };

    const getMetaData = (elm) => {
        try {
            return (
                <ul class="interview-meta">
                    <li className="fs-14">
                        <i class="ri-checkbox-circle-line"></i>
                        <span>{elm?.experienceRange}</span>
                    </li>
                    <li className="fs-14">
                        <i class="ri-checkbox-circle-line"></i>
                        <span>{elm?.difficulty}</span>
                    </li>
                    <li className="fs-14">
                        <i class="ri-checkbox-circle-line"></i>
                        <span>{elm?.questionType}</span>
                    </li>
                </ul>
            );
        } catch (error) {
            console.log("152: InterviewQuestionListAccordion : getMetaData", error);
        }
    };

    const getFollowUpQuestions = (elm) => {
        try {
            return (
                <div class="row g-5 mt--20">
                    <div class="col-lg-12 mt--0">
                        <div class="section-title text-start">
                            <span class="interview-sub-heading">Possible Related Questions:</span>
                        </div>
                    </div>
                    <div class="col-lg-12 mt-0">
                        <div class="our-mission">
                            <div class="section-title text-start">

                                <ul class="list-style-1">
                                    {elm?.followUpQuestions?.map((item, i) => {
                                        return (
                                            <li className="p-0 mb--0 fs-14">
                                                <div>
                                                    <i class="icon-checkbox-circle-fill-solid"></i>
                                                    {item?.question}
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } catch (error) {
            console.log("187: InterviewQuestionListAccordion : getMetaData", error);
        }
    };

    const getInsights = (items) => {
        try {
            // return <blockquote class="blockquote-style-2">“ This is a Quote quis eleifend quam adipiscing vitae aliquet bibendum enim facilisis gravida neque velit euismod in pellentesque massa placerat volutpat lacus laoreet non curabitured gravida odio aenean sed adipiscing.”<img class="quote-image" src="/images/icons/quote-2.png" alt="Quote Images" /></blockquote>
            return (
                <div class="row g-5 mt--20">
                    {items?.map(item => {
                        return <div class="col-lg-12 mt--0">
                            <div class="our-mission">
                                <div class="section-title text-start">
                                    <span class="interview-sub-heading">{item?.title}</span>
                                    <p>
                                        <blockquote class="blockquote-style-2 mb--0">“ {item?.content}”<img class="quote-image" src="/images/icons/quote-2.png" alt="Quote Images" /></blockquote>
                                    </p>
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            );
        } catch (error) {
            console.log("211: InterviewQuestionListAccordion : getMetaData", error);
        }
    };

    const togglePreviewModal = (questionNo) => {
        try {
            const url = `${window.location.origin}${window.location.pathname}?section=${activeTab}&page=${initialPage + 1}&question=${getQuestionNumber(questionNo, initialPage)}`;
            setShareUrl(url || "");
            setToggler(!toggler);
        } catch (error) {
            console.error(
                "222 : InterviewQuestionListAccordion : Error occurred in togglePreviewModal:",
                error && JSON.stringify(error)
            );
            throw error;
        }
    }

    return (
        <div id="revenue-cloud-fundamentals" className="pt-5 pt-lg-0 to-over">
            <Accordion
                bsPrefix="landing-demo-faq edu-accordion-02 variation-2 landing-page-accordion bg-color-transparent"
                defaultActiveKey="0"
                // activeKey={selectedQuestionId}
                flush
            >
                {currentItems &&
                    currentItems.length &&
                    currentItems.map((accordion, i) => (
                        <Accordion.Item
                            eventKey={i.toString()}
                            key={i}
                            onClick={() => toggleQuestion(i.toString(), accordion, i)}
                            bsPrefix={`edu-accordion-item ${selectedQuestionId === i.toString() ? "bg-active" : ""}`}
                            id={`question-${getQuestionNumber(i, initialPage)}`}
                        >
                            <div className="edu-accordion-header">
                                <CustomToggle eventKey={i.toString()} index={i} >
                                    Q.{getQuestionNumber(i, initialPage)} {accordion?.question || ""}
                                </CustomToggle>
                            </div>
                            <Accordion.Body bsPrefix="edu-accordion-body">

                                {getMetaData(accordion)}

                                <div className="mb-0 interview-sub-heading">ANSWER:</div>
                                <p className="mb--10 fs-14">{accordion?.answer || ""}</p>

                                {accordion?.authorInsights?.length && getInsights(accordion?.authorInsights)}

                                {accordion?.followUpQuestions?.length &&
                                    getFollowUpQuestions(accordion)}

                                {/* {accordion?.interviewInsights?.length && getInsights(accordion?.interviewInsights)} */}
                                {/* <p className="mt--10">{getAuthorInsights(accordion)}</p> */}


                                <div class="blog-tag-and-share mt--50">
                                    <div class="blog-tag">
                                        <div class="tag-list bg-shade">{getTags(accordion)}</div>
                                    </div>
                                    {/* <div class="eduvibe-post-share d-flex">
                                        <span className="mt-5 mt-sm-0">Share: </span>
                                        <div
                                            // onClick={() => handleShare(i)}
                                            onClick={() => togglePreviewModal(i)}
                                            className="clickable mt-5 mt-sm-0"
                                        >
                                            <i class="ri-share-fill"></i>
                                        </div>

                                    </div> */}
                                </div>

                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
            </Accordion>
            <div className="row mt--60 align-items-center">

                <div className="col-12 col-sm-4 d-none d-sm-flex justify-content-start">
                    <ToolTip
                        title={prevTab?.name}
                        id={"prevTab"}
                        placement="bottom"
                    >
                        <div>
                            <Link
                                className={`btn-transparent-2 text-dark truncate-custom ${prevTab ? "d-inline-block" : "d-none"}`}
                                onClick={() => handleTab(prevTab)}
                            >
                                Prev : {prevTab?.name}
                            </Link>
                        </div>
                    </ToolTip>

                </div>

                <div className="col-12 col-sm-4">
                    {/* Pagination component */}
                    <PaginationOne itemsPerPage={10} pageCount={pageCount} initialPage={initialPage} onCurrentItemsChange={handlePageClick} />
                </div>

                <div className="col-12 col-sm-4 d-none d-sm-flex justify-content-end">
                    <ToolTip
                        title={nextTab?.name}
                        id={"nextTab"}
                        placement="bottom"
                    >
                        <div>
                            <Link
                                className={`btn-transparent-2 text-dark truncate-custom ${nextTab ? "d-inline-block" : "d-none"}`}
                                onClick={() => handleTab(nextTab)}
                            >
                                Next : {nextTab?.name}
                            </Link>
                        </div>
                    </ToolTip>
                </div>

            </div>
            <div className="d-flex d-sm-none mt--60 align-items-center justify-content-end gap-3">

                <div>
                    <Link className={`edu-btn btn-dark btn-medium ${prevTab ? "d-inline-block" : "d-none"}`} onClick={() => handleTab(prevTab)}>Prev</Link>
                </div>

                <div>
                    <Link className={`edu-btn btn-dark btn-medium ${nextTab ? "d-inline-block" : "d-none"}`} onClick={() => handleTab(nextTab)}>Next</Link>
                </div>

            </div>
            <SharingModal show={toggler} onCloseModal={togglePreviewModal} url={shareUrl} />
        </div>
    );
}
